<template>
  <div class="container">
    <el-table :data="eqData" stripe border :max-height='650'>
      <el-table-column property="instrumentName" label="设备名称"></el-table-column>
      <el-table-column prop="returnPhotoUrl" label="入库照片">
        <template slot-scope="scope">
          <div v-if="scope.row.returnPhotoUrl" class="block" @click="preview(scope.row.returnPhotoUrl)">
            <el-image style="width: 60px; height: 60px" :src="scope.row.returnPhotoUrl"
              :preview-src-list="[scope.row.returnPhotoUrl]">
            </el-image>
          </div>
          <div v-else>
            <el-avatar src="https://empty" shape="square">
              <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
            </el-avatar>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="serialNumber" label="设备编号" width="120"></el-table-column>
      <el-table-column property="boxIndex" label="位置" width="100">
        <template slot-scope="{row}">
          <span v-if="row.address">{{ row.address }}</span>
          <span v-else-if="row.boxIndex">格口{{ row.boxIndex }}</span>
          <span v-else>{{ row.shelfName }}-{{ row.storeName }}</span>
        </template>
      </el-table-column>

      <el-table-column label="借出开柜时间" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.lendOpenTime">
            已开柜<br />
            <span style="font-size: 8px;-webkit-text-size-adjust:none;">{{ scope.row.lendOpenTime }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="借出关柜时间" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.lendOpenTime == null && scope.row.lendCloseTime == null"></span>
          <span v-else-if="scope.row.lendOpenTime != null && scope.row.lendCloseTime == null">取件失败</span>
          <span v-else-if="scope.row.lendOpenTime !== null && scope.row.lendCloseTime !== null">
            取件成功<br />
            <span style="font-size: 8px;-webkit-text-size-adjust:none;">{{ scope.row.lendCloseTime }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column property="states" label="归还开柜时间" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.returnOpenTime">
            已开柜<br />
            <span style="font-size: 8px;-webkit-text-size-adjust:none;">{{ scope.row.returnOpenTime }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column property="states" label="归还关柜时间" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.returnOpenTime == null && scope.row.returnCloseTime == null"></span>
          <span v-else-if="scope.row.returnOpenTime != null && scope.row.returnCloseTime == null">归还失败</span>
          <span v-else-if="scope.row.returnOpenTime !== null && scope.row.returnCloseTime !== null">
            归还成功<br />
            <span style="font-size: 8px;-webkit-text-size-adjust:none;">{{ scope.row.returnCloseTime }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column property="states" label="状态" width="140">
        <template slot-scope="scope">
          {{ eqStates[scope.row.states - 1] }}<br />
          <!-- <span style="font-size: 8px;-webkit-text-size-adjust:none;text-align: center;">{{
            scope.row.updateTime ? scope.row.updateTime : "" }}</span> -->
        </template>
      </el-table-column>

      <el-table-column label="操作" width="130" align="center">
        <template slot-scope="scope">
          <!-- 取出 -->
          <el-button @click="takeOutAndReturn('QC', scope.row.id, scope.row.hasUsingInfo)" v-if="scope.row.status == 5"
            size="small" type="text">取出</el-button>

          <!-- 归还 -->
          <el-button @click="takeOutAndReturn('GH', scope.row.id, scope.row.hasUsingInfo)" v-if="scope.row.status == 6"
            size="small" type="text">归还</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 管理员填写时间 -->
    <el-dialog append-to-body title="取出/归还时间" :visible.sync="centerDialogVisible" width="400px" center>
      <el-date-picker v-model="curTime" :clearable="false" type="datetime" placeholder="选择日期时间">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnIns, takeOutIns } from "@/api/dataMana.js"
import { formatDate } from '@/util/util.js'
export default {
  props: ['eqData'],
  data() {
    return {
      hasUsingInfo: null,
      curId: null,
      visibleState: '',
      centerDialogVisible: false,
      curTime: null,
      takeOutVisible: false,
      giveBackVisible: false,
      imagesDialogVisible: false,
      images: '',
      eqStates: ['预约中', '预约失败', "取消使用", "预约成功,未领用", "使用中", "逾期", "归还未入库", "完成"],
    }
  },
  computed: {
    roles() {
      // "设备管理员:2" 管理员 1
      return this.$store.state.user.userInfo.roleId
    }
  },
  methods: {
    //图片预览
    preview(images) {
      this.images = images
      this.imagesDialogVisible = true
    },
    takeOutAndReturn(value, id, hasUsingInfo) {
      if (hasUsingInfo != 1 && value == 'GH') {
        this.$message.success("该仪器未填写使用记录！");
        return
      }
      this.curId = id
      this.visibleState = value,
        this.centerDialogVisible = true
      this.curTime = new Date()
    },
    submit() {
      if (this.visibleState == 'QC') {
        let self = this;
        takeOutIns({
          id: self.curId,
          lendTime: formatDate(self.curTime, 'all')
        }).then(res => {
          if (res.code == '200') {
            self.$message.success(res.msg || res.message || "取出成功！");
            self.centerDialogVisible = false
            self.$emit("refresh", {})
          } else {
            self.$message.error(res.msg);
          }
        }).catch(err => {
          self.$message.error(err.msg || err.message || "服务器连接失败");
        })
      }
      if (this.visibleState == 'GH') {
        let self = this;

        returnIns({
          id: self.curId,
          returnTime: formatDate(self.curTime, 'all')
        }).then(res => {
          if (res.code == '200') {
            self.$message.success(res.msg || res.message || "归还成功！");
            self.centerDialogVisible = false
            self.$emit("refresh", {})
          } else {
            self.$message.error(res.msg);
          }
        }).catch(err => {
          self.$message.error(err.msg || err.message || "服务器连接失败");
        })
      }

    },

  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Datamanagement/Applicationmana/components/eqList.vue